import { ShouldRenderTabsService } from '@philips-emr/hpms-provider-commons';
import { TabControlAPI, TabWithContentAPI } from '@philips-emr/tws-components';
import Controller, { OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';

import { FragmentNames } from '../../codegen';
import { AccreditationProfessionalsAliases as Aliases } from '../../codegen/constants/aliases/accreditation-professionals-aliases';
import BaseController from '../BaseController';

enum EmployeesAndAmountProfessionals {
  EMPLOYEES = 'employees',
  AMOUNT_PROFESSIONALS = 'amountProfessionals',
}

@Controller({ fragment: FragmentNames.ACCREDITATION_PROFESSIONALS })
export default class ProviderAccreditatonProfessionalsController extends BaseController {

  @OnMount(Aliases.TAB_CONTROL)
  onMountTab(event: MountEvent): void {
    const api = event.target as TabControlAPI;
    ShouldRenderTabsService.chooseDefaultTab(api, [EmployeesAndAmountProfessionals.EMPLOYEES, EmployeesAndAmountProfessionals.AMOUNT_PROFESSIONALS]);
  }

  @OnMount(Aliases.TAB_EMPLOYEES)
  onMountEmployees(event: MountEvent): void {
    const api = event.target as unknown as TabWithContentAPI;
    ShouldRenderTabsService.shouldRenderTab(api, EmployeesAndAmountProfessionals.EMPLOYEES);
  }

  @OnMount(Aliases.TAB_AMOUNT_PROFESSIONALS)
  onMountProfessionalsTab(event: MountEvent): void {
    const api = event.target as unknown as TabWithContentAPI;
    ShouldRenderTabsService.shouldRenderTab(api, EmployeesAndAmountProfessionals.AMOUNT_PROFESSIONALS);
  }

}
